<template>
    <div class="article-column">
        <article-list-skeleton v-if="loading" style="margin-bottom: 100vh"></article-list-skeleton>
        <div v-else>
            <div class="article-column-head">
                <div class="article-column-head-title">
                    <img src="/static/img/icon_list_tag_column.svg" alt="" />
                    {{ article.title }}
                </div>
                <div class="article-column-head-detail">已更新{{ article.current_count }}篇 | 共{{ article.total_count }}篇</div>
                <van-button type="primary" @click="handleStatus(article)" v-if="!article.is_subscribe && !loading">
                    <img src="@/assets/medical/medical-follow.svg" />
                    关注
                </van-button>
                <van-button @click="handleStatus(article)" v-if="article.is_subscribe && !loading">
                    <img src="@/assets/medical/medical-follow.svg" />
                    已关注
                </van-button>
            </div>

            <div class="article-column-body">
                <div class="article-list-section" v-if="article.items.length > 0">
                    <van-row class="article-list-section-box" @click="goArticle(item)" v-for="item in article.items" :key="item.id">
                        <van-col span="8">
                            <van-image fit="cover" class="article-list-content-img" :src="item.cover_img" width="100%" height="74" />
                        </van-col>
                        <van-col span="16" class="article-list-content">
                            <div class="article-list-title">{{ item.title.length > 34 ? item.title.substr(0, 34) + '...' : item.title }}</div>

                            <div class="article-list-content-detail">
                                <div>
                                    {{ item.created_at }}
                                    <span style="margin-left: 8px">{{ item.view_count }}人阅读</span>
                                </div>
                            </div>
                        </van-col>
                    </van-row>
                </div>
                <div class="van-list__finished-text" v-if="article.items.length > 0 && page === total_page">没有更多了</div>
                <div v-else-if="article.items.length > 0 && total_page > page" class="finish-more" @click="fetch_more()">查看更多</div>
                <van-empty v-else description="" image="/static/img/pic_blank_content.svg">
                    <template slot="description">
                        <div style="text-align: center">没有更多了</div>
                        <div style="text-align: center">博医荟持续更新中…</div>
                        <div style="text-align: center;margin-top: 10px">先看看其他内容吧！</div>
                        <div style="text-align: center;margin-top: 24px">
                            <van-button color="#D3172E" round size="small" style="width: 120px" :to="'/'">
                                返回首页
                            </van-button>
                        </div>
                    </template>
                </van-empty>
            </div>
        </div>
    </div>
</template>
<script>
import Interface from '@/util/interface'
import articleListSkeleton from '@/skeleton/articleListSkeleton'
export default {
    name: 'article-list',
    components: {
        'article-list-skeleton': articleListSkeleton
    },
    data() {
        return {
            value: '',
            active: '',
            category_id: 0,
            category_child_id: 0,
            category_index: 0,
            banners: [],
            categories: [],
            categories_child: [],
            recommend: [],
            list: [],
            column: [],
            loading: true,
            page: 1,
            pageSize: 10,
            total_page: 1,
            id: 0,
            article: {
                items: []
            },
            type: false,
            pageID: null
        }
    },
    methods: {
        handleStatus(row) {
            if (!row.is_subscribe) {
                this.pageID = row.id
                this.fetch('subscribe')
                return
            }
            this.$dialog
                .confirm({
                    title: '提醒',
                    message: '确定取消关注吗？',
                    confirmButtonText: '确定',
                    className: 'dly-dialog'
                })
                .then(() => {
                    this.type = true
                    this.pageID = row.id
                    this.fetch('subscribe')
                })
                .catch(() => {
                    console.log(1)
                })
        },
        onSearch() {
            this.fetch('article')
        },
        onCancel() {
            this.value = ''
            this.fetch('article')
        },
        fetch(scene) {
            if (scene === 'article') {
                Interface.getData('get', Interface.article.detail + '/' + this.id).then(res => {
                    console.log(res)
                    if (res.data.items == null) {
                        res.data.items = []
                    }
                    this.article = res.data
                    if (this.article) {
                        Interface.getShareInfo(this, this.article.title, this.article.cover_img, this.article.desc, 6, this.id)
                        Interface.mFootPrint(this.id,6,2,'',0,this.article.title)
                    }
                    setTimeout(() => {
                        this.loading = false
                    }, 500)
                })
            } else if (scene === 'subscribe') {
                Interface.getData('get', Interface.medical.subscribe + this.pageID).then(res => {
                    if (res.code === 0) {
                        if (this.type) {
                            this.$toast.success('取消关注成功')
                            this.type = false
                            this.pageID = null
                        } else {
                            this.$toast.success('关注成功')
                        }
                        this.fetch('article')
                    } else {
                        this.$toast(res.message)
                    }
                })
            }
        },
        fetch_more() {
            this.page += 1
            let params = {
                page: this.page,
                pageSize: 10,
                category_id: this.category_id
            }
            Interface.getData('get', Interface.article.list, params).then(res => {
                this.article.items.push(...res.data.list)
                this.total_page = res.data.total_page
            })
        },
        goArticle(item) {
            Interface.goArticle(this,item,false)
        }
    },
    created() {
        this.id = this.$route.params.id
        this.fetch('article')
        let source_type = Interface.getUrl(window.location.href)
        if (source_type) {
            Interface.mFootPrint(this.id, 6,'', 0, source_type, this.article.title)
        }
    }
}
</script>

<style lang="scss">
@import './index.scss';
</style>



// WEBPACK FOOTER //
// src/views/article/column/index.vue